//Make sure controller & component names are different from portal's!
(function (ng, app) {
    app.config([
        '$stateProvider',
        function ($stateProvider) {
            $stateProvider.state('Onboarding',
                {
                    url: '/Onboarding',
                    component: 'onboardingComponent',
                    resolve: {
                        user: ["homeApi", function (homeApi) {
                            return homeApi.getUserInfo();
                        }],
                        userGroup: ["userGroupApi", "user", function (userGroupApi, user) {
                            if (user.UserGroupId)
                                return userGroupApi.get(user.UserGroupId);
                            return null;
                        }],
                        logo: ["userGroupApi", "user", "portalBaseApiUrl", function (userGroupApi, user, portalBaseApiUrl) {
                            if (user.UserGroupId) {
                                var logoUrl = portalBaseApiUrl + "/UserGroups/" + user.UserGroupId + "/Logo";
                                if (localStorage.getItem("UserGroupLogo") === null
                                    || localStorage.getItem("UserGroupLogo") !== logoUrl) {
                                    localStorage.setItem("UserGroupLogo", logoUrl);
                                    localStorage.setItem("UserGroupId", user.UserGroupId);
                                }
                                return logoUrl;
                            } else {
                                localStorage.removeItem("UserGroupLogo");
                                localStorage.removeItem("UserGroupId");
                            }
                            return null;
                        }],
                        delegates: ["userApi", "user", function (userApi, user) {
                            return userApi.getUsersForDelegateUser(user.Id);
                        }],
                        onBehalfOfUser: ["userApi", "permissionService", function (userApi, permissionService) {
                            var onBehalfOfUserId = permissionService.getOnBehalfOfUserId();
                            if (onBehalfOfUserId)
                                return userApi.get(onBehalfOfUserId).catch(ng.noop);
                            return null;
                        }],
                        permissions: ["permissionApi", "permissionService", function (permissionApi, permissionService) {
                            return permissionApi.getPolicyStatements().then(function (response) {
                                permissionService.setPermissions(response);
                            });
                        }],
                        masterAdvisorAgreementRequiredRecord: ["agreementsApi", function (agreementsApi) {
                            return agreementsApi.getMasterAdvisorAgreementRequiredRecord().then(function (model) {
                                if (model.data === "")
                                    return null;
                                return model;
                            });
                        }],
                        userMasterAdvisorAgreement: ["agreementsApi", function (agreementsApi) {
                            return agreementsApi.getLoggedInUserMasterAdvisorAgreement().then(function (agreement) {
                                if (agreement.data === "")
                                    return null;
                                return agreement;
                            }, function () {
                                return null;
                            });
                        }],
                        onBehalfOfUserGroup: ["userApi", "permissionService", "userGroupApi", function (userApi, permissionService, userGroupApi) {
                            var onBehalfOfUserId = permissionService.getOnBehalfOfUserId();
                            if (onBehalfOfUserId)
                                return userApi.get(onBehalfOfUserId).then(function (user) {
                                    if (user.UserGroupId)
                                        return userGroupApi.get(user.UserGroupId);
                                    return null;
                                });
                            return null;
                        }],
                    },
                    redirectTo: function (trans) {
                        var onBehalfOfUser = trans.injector().getAsync('onBehalfOfUser');
                        return onBehalfOfUser.then(function (result) {
                            if (result) {
                                // redirect them if they are viewing as an on behalf of user
                                return 'Home.Dashboard';
                            }
                            //var isOnboarding = $cookies.get("is-onboarding") === "true"
                            //    ? true
                            //    : false;

                            //if ([needs MAA] && ![has MAA] ) { return 'Onboarding.Agreement' }
                            //else if ([has MAA] && ![hasSureLC]) { return 'Onboarding.CarrierSetup'}
                            return 'Onboarding.Welcome';
                        });
                    },
                });
        }
    ]);

    app.component('onboardingComponent', {
        templateUrl: 'App.Onboarding/Onboarding.template.html',
        controller: 'OnboardingController',
        bindings: {
            user: "<",
            userGroup: "<",
            logo: "<",
            delegates: "<",
            onBehalfOfUser: "<",
            masterAdvisorAgreementRequiredRecord: "<",
            masterAdvisorAgreements: "<",
            userMasterAdvisorAgreement: "<"
        }
    });

    app.controller('OnboardingController', OnboardingController);

    OnboardingController.$inject = ['_', 'agreementsApi', 'AuthService', '$cookies', 'externalLoading', '$location', '$mdSidenav', 'onboardingApi', 'permissionApi', 'permissionService', '$rootScope', 'ssoApi', '$state', '$timeout', 'userApi', '$window'];

    function OnboardingController(_, agreementsApi, AuthService, $cookies, externalLoading, $location, $mdSidenav, onboardingApi, permissionApi, permissionService, $rootScope, ssoApi, $state, $timeout, userApi, $window) {
        var $ctrl = this;
        $rootScope.$on('$locationChangeSuccess', function () {
            $rootScope.actualLocation = $location.path();
        });
        $rootScope.$watch(
            function () {
                // TODO: is this redundant with the proceeding if else
                $ctrl.ui.activeState = _getState();
                return $location.path();
            },
            function (newLocation, oldLocation) {
                if ($rootScope.actualLocation === newLocation) {
                    //alert('Why did you use history back?');
                    //console.log("new: " + newLocation + "\n old: " + oldLocation);
                    $ctrl.ui.activeState = _getState();
                }
                else { $ctrl.ui.activeState = _getState(); }
            }
        );

        ng.extend($ctrl, {
            ui: {
                activeState: _getState(),
                loading: false
            },
            isOnboarding: $cookies.get('is-onboarding'),
            nav: [
                {
                    Id: 0,
                    Name: 'Welcome',
                    Url: 'Welcome',
                    Description: "Let's get started!."
                },
                {
                    Id: 1,
                    Name: 'Agreement',
                    Url: 'Agreement',
                    Description: 'Knock out the formalities first..'
                },
                {
                    Id: 2,
                    Name: 'Carrier Setup',
                    Url: 'CarrierSetup',
                    Description: 'Get ready to write your first case',
                    DescriptionLong: 'Get contracted and ready to write your first case.'
                },
                {
                    Id: 3,
                    Name: 'Training',
                    Url: 'Training',
                    Description: 'Get a headstart on your carrier training'
                },
                {
                    Id: 4,
                    Name: 'Portal',
                    Url: 'PortalPreview',
                    Description: ''
                }
            ]
        });

        //filter nav permisions as needed 
        $ctrl.nav = _.filter($ctrl.nav,
            function (row) {
                var show = true; //default show all nav items
                if (row.ShowIfAll) {
                    show = permissionService.hasAllPermissions(row.ShowIfAll);
                }
                if (row.HideIfOne)
                    if (permissionService.hasOnePermission(row.HideIfOne, true))
                        show = false;
                return show;
            });

        $ctrl.toggleNav = function (navId) {
            $mdSidenav(navId).toggle();
        };

        $ctrl.logout = function () {
            AuthService.logout();
        };
        function _getState() {
            var urlTrunk = $state.$current.name.split(".", 2)[1]
            return _.find($ctrl.nav, function (state) { return state.Url === urlTrunk; });
        }

        $ctrl.completeContracting = function () {
            $ctrl.isRedirecting = true;

            // Post to Onboarding api to complete contracting
            onboardingApi.updateContractingCompleted()
                .finally(function () {
                    $ctrl.completedSureLc = true;
                    //update permissions
                    userApi.updateOnboardingCompletedPermissions($ctrl.user.Id).then(function () {
                        // update permissions cookie
                        permissionApi.getPolicyStatements().then(function (response) {
                            permissionService.setPermissions(response);
                        });
                    });
                });
        };

        $ctrl.createAgreement = function () {
            $ctrl.isRedirecting = true;

            // TODO: replace with endpoint for Onbaording 
            agreementsApi.initMasterAdvisorAgreement($ctrl.workflow)
                .then(function (result) {
                    //$ctrl.ui.showIframe = true;
                    console.log(result);
                    // TODO complete process for new iframe completion
                    // TODO: add ng-disabled to next button to disable when not signed or skipped
                    //$window.open(result, 'MaaIframe');
                    $window.open(result, '_self');
                })
                .catch(function (error) {
                    console.log(error);
                    if (error.data === 'An agreement for this user already exists.') {
                        $ctrl.docIsSigned = true;
                        //$ctrl.ui.showIframe = false;
                    }
                    $ctrl.signError = true;
                })
                .finally(function () {
                    $ctrl.isRedirecting = false;
                });
        };

        $ctrl.goToNext = function () {
            if ($ctrl.ui.activeState.Id !== $ctrl.nav.length - 1) {
                var toStateId = $ctrl.ui.activeState.Id + 1;
                var toState = _.find($ctrl.nav, function (state) { return state.Id === toStateId; });
                $state.go('Onboarding.' + toState.Url);
            }
            else $state.go('Home');
        };

        $ctrl.goToPrevious = function () {
            //console.log($ctrl.ui.activeState.Id === 1 && (!$ctrl.docIsSigned || !$ctrl.signError));
            if ($ctrl.ui.activeState.Id !== 0) {
                var toStateId = $ctrl.ui.activeState.Id - 1;
                var toState = _.find($ctrl.nav, function (state) { return state.Id === toStateId; });
                $state.go('Onboarding.' + toState.Url);
            }
        };

        $ctrl.goToState = function (name) {
            if (name) $state.go('Onboarding.' + name);
        }

        $ctrl.goToSureLc = function () {
            $ctrl.isRedirecting = true;
            // Todo: figure out what this code does (copied from the App.Portal CarriersTraining)
            // Not sure if onBehalfOfUserGroup and userGroup are being populated
            $ctrl.userGroup = $ctrl.onBehalfOfUserGroup || $ctrl.userGroup;

            if ($ctrl.userGroup && $ctrl.userGroup.AffiliationLink) {
                $window.open($ctrl.userGroup.AffiliationLink);
            }

            else {
                var w = $window.open();
                w.document.write(externalLoading.html);

                ssoApi.initiateSureLcSso($ctrl.sureLcUser.LastName).then(function (data) {
                    w.document.write(data);
                    w.document.forms.surelc.submit();
                }, function (error) {
                    w.document.write(" Failed.  There was an error accessing this resource.");
                });
            }

            $timeout(function () {
                $ctrl.isRedirecting = false;
                $ctrl.goToNext();
            }, 5000);
            $ctrl.completeContracting();
        };

        $ctrl.setCookie = function () {
            $cookies.put("is-onboarding", 'true');
        };

        $ctrl.removeCookie = function () {
            $cookies.remove("is-onboarding");
        };

        $ctrl.selectOnBehalfOfUser = function (delegateId) {
            var delegate = $ctrl.delegates.find(function (row) { return row.Id === delegateId; });
            if (delegate) {
                $ctrl.delegateId = delegateId;
                permissionService.setOnBehalfOfUserId(delegate.OnBehalfOfUserId);
                permissionService.setUserDelegateId(delegate.Id);
                return permissionApi.getDelegatePermissions(delegate.Id).then(function (permissions) {
                    permissionService.setPermissions(permissions);
                    $state.go("Home.Dashboard", {}, { reload: true });
                });
            }
        };

        $ctrl.selectMeAsUser = function () {
            $ctrl.delegateId = null;
            userApi.getLoggedInUserPermissions().then(function (permissions) {
                permissionService.removeStoredOnBehalfOfUserId();
                permissionService.setPermissions(permissions);
                $state.go("Onboarding.Welcome", {}, { reload: true });
            });
        };

        $ctrl.$onInit = function () {
            !!$ctrl.isOnboarding ? '' : $ctrl.setCookie();
            $ctrl.delegateId = permissionService.getUserDelegateId();
            ssoApi.getSureLcUser().then(function (user) {
                $ctrl.sureLcUser = user;
            });
            onboardingApi.getContractingCompleted().then(function (response) {
                $ctrl.completedSureLc = response;
            });
        };
    }
})(window.angular, window.app);